import { sagaCreator } from '@adrias-online/steiner';

import helper from 'helpers/steinerHelper';
import { actions, actionTypes } from '../actions/articoli';
import { selectors, DEFAULT_STATE } from '../reducers/articoli';
import api from '../apis/articoli';

const sagas = helper.createSagas(
    'articoli',
    actionTypes,
    actions,
    api,
    selectors,
    DEFAULT_STATE
);

const defaultSagas = sagaCreator.bootSagas(sagas, actionTypes);

export default [...defaultSagas];
